import SetPassword from "./SetPassword";
import './setPassword.scss';

export default SetPassword;